import React, { Component } from "react";
import { Button, Modal, ModalBody } from "reactstrap";

import ApiBuy from "../../utils/api.buy";
import ApiNgos from "../../utils/api.ngos";
import ApiProfile from "../../utils/api.profile";
import ApiHallOfFame from "../../utils/api.halloffame";
import Loading from "../../components/Loading";
import ShowValue from "../../components/ShowValue";
import AuthService from "../../utils/auth.service";

declare var location;
declare var firebase;
declare var FB;

class BuyModal extends Component {
  authService = AuthService;
  constructor(props) {
    super(props);
    let profile = localStorage.getItem("userData");

    if (profile) {
      profile = JSON.parse(profile);
    }

    this.setState({ loading: true });

    this.state = {
      donation: profile ? profile.donation : 20,
      transaction: this.props.transaction,
      loading: false,
      code: "",
      ngos: [],
      profile: profile,
      ngo: this.props.transaction.ngo,
      disableButton: false
    };

    /*console.log('BuyModal');
    console.log(profile); */

    /*firebase.auth().onAuthStateChanged(user => {
      if(user) {
 
        new ApiProfile().getProfile().then(response => {
            this.setState(...this.state, { profile: response.data });
        })
      }
    });*/

    document.addEventListener("profileLoaded", data => {
      if (data.detail) {
        let profile = data.detail.profile;
        this.setState(...this.state, { profile: profile });
      }
    });

    document.addEventListener("profileSave", data => {
      if (data.detail) {
        let profile = data.detail.profile;
        this.setState(...this.state, { profile: profile });
        this.setState(...this.state, {
          donation: this.state.profile ? this.state.profile.donation : 20
        });
      }
    });

    document.addEventListener("profileLogout", data => {
      if (data.detail) {
        let profile = localStorage.getItem(
          "userData"
        ); /*  data.detail.profile;*/
        if (profile) {
          profile = JSON.parse(profile);
        }
        this.setState(...this.state, { profile: profile });
      }
    });

    ApiNgos.get().then(response => {
      if (response.data) {
        this.setState(...this.state, { ngos: response.data });
      }
    });

    this._bindToContext("shareFB");
    this._bindToContext("checkNextAction");
    this._bindToContext("handleInputChange");
    this._bindToContext("responseGoogle");
  }

  _bindToContext(f) {
    if (this[f] instanceof Function) {
      this[f] = this[f].bind(this);
    }
  }

  responseGoogle(googleUser) {
    let provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope("https://www.googleapis.com/auth/plus.login");
    firebase.auth().languageCode = "pt";

    firebase.auth().signInWithPopup(provider).then(
      result => {
        this.props.changeAssetLine(this.state.transaction.asset_line);
        this.props.buyAsset();
        this.setState(...this.state, { profile: {} });
      },
      err => { }
    );
  }

  componentWillReceiveProps(props) {
    if (
      this.state.transaction.status !== "approved" ||
      props.transaction.asset_line !== this.state.transaction.asset_line ||
      props.transaction.error
    ) {
      this.setState(...this.state, {
        transaction: props.transaction,
        ngo: props.transaction.ngo
      });
    }

    this.setState(...this.state, {
      donation: this.state.profile ? this.state.profile.donation : 20
    });
  }

  checkNextAction() {
    if (this.state.profile && this.state.profile.tfa_active && this.state.transaction.status !== "tfa") {
      this._changeToTfaTransaction();
    } else if (this.state.transaction.key) {
      this._confirmUserBuy();
    }
  }

  _changeToTfaTransaction() {
    this.setState(...this.state, {
      transaction: {
        ...this.state.transaction,
        status: "tfa"
      }
    });
  }

  _confirmUserBuy() {
    this.setState(...this.state, { loading: true, disableButton: true });
    if (!this.state.disableButton) {
      new ApiBuy().confirm({
        transaction: this.state.transaction.key,
        donation: this.state.donation,
        ngo: this.state.ngo,
        loading: false,
        code: this.state.code
      }).then(response => {
        if (response.data) {
          if (response.data.status === 401) {
            this.setState(...this.state, {
              loading: false,
              transaction: {
                ...this.state.transaction,
                message: response.data.message,
                status: response.data.status,
                error: true
              },
              disableButton: false
            });
            ApiHallOfFame.post().then(response => {
              return response;
            });
            this.props.changeAssetLine(this.state.transaction.asset_line);
          } else {
            this.setState(...this.state, {
              transaction: response.data,
              loading: false
            });
            this.authService.refresh();
            if (response.data.status !== "refused") {
              this.props.changeAssetLine(this.state.transaction.asset_line);
            }
          }
        }
      }).catch(error => {
        console.log(`error: ${error}`);
      });
    }
  }

  totalSum() {
    let total = 0;
    if (this.state.transaction.transaction) {
      this.state.transaction.transaction.forEach(trans => {
        total += trans.value_pair.value;
      });
    }
    return <ShowValue btc={total + this.state.transaction.fee} />;
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState(...this.state, { [name]: value });
  }

  tableItems() {
    return this.state.transaction.transaction.map((t, index) => {
      if (index == 1) {
        return (
          <tr key={index + 1}>
            <th scope="row">
              <img src={t.frontend_info.image} className="img-fluid d-block m-auto" width="35" />
            </th>
            <td>{t.frontend_info.description}</td>
            <td className="p-0 m-0">
              <select name="ngo" onChange={this.handleInputChange} value={this.state.ngo} className="form-control">
                {this.state.ngos.map(ngo => (
                  <option key={ngo.key} selected={t.value_pair.address === ngo.ngo_btc_address ? "selected" : ""} value={ngo.key}>
                    {ngo.name}
                  </option>
                ))}
              </select>
            </td>
            <td>
              <ShowValue btc={t.value_pair.value} />
            </td>
          </tr>
        );
      } else {
        return (
          <tr key={index + 1}>
            <th scope="row">
              <img src={t.frontend_info.image} className="img-fluid d-block m-auto" width="35" />
            </th>
            <td>{t.frontend_info.description}</td>
            <td>
              {t.frontend_info.name ? t.frontend_info.name : this.props.current.previous_landers[0].name}
            </td>
            <td>
              <ShowValue btc={t.value_pair.value} />
            </td>
          </tr>
        );
      }
    });
  }

  shareFB() {
    let ngo_values, donation_value, ngo_name;
    if (this.state.transaction.transaction[1]) {
      ngo_values = this.state.transaction.transaction[1];
      donation_value = ngo_values.value_pair.value;
      ngo_name = ngo_values.frontend_info.name.split("Default: ")[1];
    }
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Hey facebook friends, I\'ve just bought a new asset at Cryptolands.io! Check this out. The asset name is ${
          this.props.current.name
          } and I\'ve donated ${donation_value} satoshis to ${ngo_name}!`,
        href: location.href
      },
      function (response) { }
    );
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="modal-lg">
        <ModalBody>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <h1 className="mb-1">Buying: {this.props.current.name}</h1>
              </div>
            </div>{" "}
            {/* Message Buying */}
            <div className="row justify-content-center">
              <div className="col-md-8">
                <p className="text-center" hidden={this.state.transaction.status !== "approved"}>
                  Congratulations! <br /> You are the new{" "}
                  {this.props.current.level_name} {this.props.current.name}{" "}
                  owner.
                </p>
                <p className="text-center" hidden={this.state.transaction.status !== "not-allowed"}  >
                  It seems that you already own this asset. You're not allowed
                  to buy the same asset twice.
                </p>
                <p className="text-center" hidden={this.state.transaction.status !== "refused"}>
                  You do not have sufficient funds to complete this action,
                  transfer some and try again.
                </p>
                <p className="text-center" hidden={!this.state.transaction.error} >
                  {this.state.transaction.message}
                </p>
              </div>
            </div>{" "}
            {/* Messages */}
            <div className="row justify-content-center" hidden={this.state.transaction.status === "not-allowed" || this.state.transaction.status === "refused" || this.state.transaction.error || this.state.transaction.status === "approved"} >
              <div className="col-md-2">
                <img className="img-fluid" src={this.props.current.image} alt="main asset" />
              </div>{" "}
              {/* Image */}
              <div className="col-md-6">
                <div className="row justify-content-center">
                  <div className="col-md-5">
                    <p className="pt-1 text-center text-price">You</p>
                    <table className="w-95">
                      <thead>
                        <tr>
                          <th className="w-40" />
                          <th className="w-60" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <p>Price:</p>
                          </td>
                          <td>
                            <p className="mb-2 pt-1 text-right">
                              <ShowValue btc={this.props.current.previous_landers[0].previous_lander_asset_price} />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Fee:</p>
                          </td>
                          <td>
                            <p className="mb-2 text-right">
                              <ShowValue btc={this.state.transaction.fee} />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Total:</p>
                          </td>
                          <td>
                            <p className="text-right mb-2">
                              <ShowValue btc={this.props.current.previous_landers[0].previous_lander_asset_price + this.state.transaction.fee} />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>{" "}
                  {/* Table Price - Fee - Total */}
                  <div className="col-md-6">
                    <p className="pt-1 text-center text-price"> Next Lander </p>
                    <table className="w-95">
                      <thead>
                        <tr>
                          <th className="w-40" />
                          <th className="w-60" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <p>New Price:</p>
                          </td>
                          <td>
                            <p className="mb-2 pt-1 text-right float-right">
                              <ShowValue btc={Math.round(this.props.current.previous_landers[0].previous_lander_asset_price * (1.4 + this.state.donation / 100.0))} />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="pt-4">
                      Price Increase:{" "}
                      <strong>{Number(this.state.donation) + 40}%</strong>
                    </p>
                    <input name="donation" onChange={this.handleInputChange} value={this.state.donation} style={{ width: "55%", display: "block" }} type="range" min="20" max="60" step="5" />
                  </div>{" "}
                  {/* Donation input */}
                </div>{" "}
                {/* Buying Table */}
              </div>
              {/* Buying Table */}
            </div>{" "}
            {/* Buying Table */}
            <div className="row justify-content-center" hidden={this.state.transaction.status !== "tfa"}  >
              <div className="col-md-4">
                <hr />
                <div className="form-group">
                  <label htmlFor="code">
                    TFA secure active, confirm your code:
                  </label>
                  <input type="text" autoComplete="off" onChange={this.handleInputChange} name="code" maxLength="7" className="form-control" />
                </div>
              </div>
            </div>{" "}
            {/* TFA */}
            <div className="row justify-content-center" hidden={this.state.transaction.status !== "pending" || this.state.transaction.error} >
              <div className="col-md-8">
                <div hidden={this.state.transaction.status === "not-allowed" || this.state.transaction.status === "refused" || this.state.transaction.error} >
                  <table className="table table-dark">
                    <tbody>
                      {this.tableItems()}
                      <tr>
                        <th>
                          <i className="fab fa-bitcoin fa-2x m-auto d-block" />
                        </th>
                        <td>You are paying fees to:</td>
                        <td>Bitcoin Blockchain</td>
                        <td>
                          <ShowValue btc={this.state.transaction.fee} />
                        </td>
                      </tr>
                      <tr>
                        <td />
                        <td>You spend (including Bitcoin fee):</td>
                        <td>Total amount spent --------> </td>
                        <td>{this.totalSum()}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>{" "}
            {/* Dividendends Table */}
            <div className="row justify-content-center">
              <div className="col-md-8">
                <button className="btn btn-outline-success float-right" hidden={this.state.transaction.error || (this.state.transaction.status !== "pending" && this.state.transaction.status !== "tfa") || !this.state.profile} onClick={this.checkNextAction} disabled={!this.props.current.previous_landers[0].previous_lander_asset_price || this.state.disableButton}>
                  Confirm Buy
                </button>{" "}
                {/* Confirm buy*/}
                <button className="google-login float-right" onClick={this.responseGoogle} hidden={this.state.profile} >
                  <img className="google-img" width="20" alt="Logo Google" src="/assets/images/logo-google.png" />
                  <span className="google-text">Log in to Buy</span>
                </button>{" "}
                {/* Login to buy */}
                <Button color="secondary" className="float-left" onClick={this.props.toggle} >
                  Back
                </Button>{" "}
                {/* Cancel or Ok? */}
                {/*<Link className="btn btn-outline-secondary"
                        to={ this.props.toggle }>
                        <i className="fas fa-caret-left"></i>
                    Back
                  </Link> */}{" "}
                {/* Back - Why this is not a button? */}
                <button className="btn btn-outline-primary float-right" hidden={this.state.transaction.status !== "approved"} onClick={this.shareFB} >
                  <i className="fab fa-facebook-f" />
                  Share
                </button>{" "}
                {/* Share */}
              </div>
            </div>{" "}
            {/* Buying Buttons */}
          </div>{" "}
          {/* Modal Body */}
        </ModalBody>
        <Loading active={this.state.loading} />
      </Modal >
    );
  }
}

export default BuyModal;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/buy-modal.js